import { SuggestedBuildings } from '../../services/search';
import { Unit } from '../../services/units';
import { ActionInterface } from '../../utils/redux';
import { SearchActions } from './actions';
import SearchState, { SearchStateInterface } from './state';

const INITIAL_STATE = new SearchState();

export default function SearchReducer(
  state = INITIAL_STATE,
  action: ActionInterface<SearchActions>
): SearchStateInterface {
  switch (action.type) {
    case SearchActions.getStaticSuggestedBuildingsStart:
      return getStaticSuggestedBuildingsStart(state);
    case SearchActions.getStaticSuggestedBuildingsSuccess:
      return getStaticSuggestedBuildingsSuccess(state, action);
    case SearchActions.getStaticSuggestedBuildingsError:
      return getStaticSuggestedBuildingsError(state, action);
    case SearchActions.getSuggestedBuildingsStart:
      return getSuggestedBuildingsStart(state);
    case SearchActions.getSuggestedBuildingsSuccess:
      return getSuggestedBuildingsSuccess(state, action);
    case SearchActions.getSuggestedBuildingsError:
      return getSuggestedBuildingsError(state, action);
    case SearchActions.searchUnitsStart:
      return searchUnitsStart(state);
    case SearchActions.searchUnitsSuccess:
      return searchUnitsSuccess(state, action);
    case SearchActions.searchUnitsError:
      return searchUnitsError(state, action);
    case SearchActions.setResults:
      return setUnitResults(state, action);
    default:
      return state;
  }
}

// reducers
function getStaticSuggestedBuildingsStart(
  state: SearchStateInterface
): SearchStateInterface {
  return { ...state, error: undefined };
}
function getStaticSuggestedBuildingsSuccess(
  state: SearchStateInterface,
  action: ActionInterface<SearchActions, SuggestedBuildings>
): SearchStateInterface {
  return { ...state, error: null, suggestions: action.payload || null };
}
function getStaticSuggestedBuildingsError(
  state: SearchStateInterface,
  action: ActionInterface<SearchActions>
): SearchStateInterface {
  return { ...state, error: action.payload, suggestions: null };
}
function getSuggestedBuildingsStart(
  state: SearchStateInterface
): SearchStateInterface {
  return { ...state, error: undefined };
}
function getSuggestedBuildingsSuccess(
  state: SearchStateInterface,
  action: ActionInterface<SearchActions, SuggestedBuildings>
): SearchStateInterface {
  return { ...state, error: null, suggestions: action.payload || null };
}
function getSuggestedBuildingsError(
  state: SearchStateInterface,
  action: ActionInterface<SearchActions>
): SearchStateInterface {
  return { ...state, error: action.payload, suggestions: null };
}
function searchUnitsStart(state: SearchStateInterface): SearchStateInterface {
  return { ...state, error: undefined };
}
function searchUnitsSuccess(
  state: SearchStateInterface,
  action: ActionInterface<SearchActions, Unit[]>
): SearchStateInterface {
  return { ...state, error: null, results: action.payload || [] };
}
function searchUnitsError(
  state: SearchStateInterface,
  action: ActionInterface<SearchActions>
): SearchStateInterface {
  return { ...state, error: action.payload, query: null, results: [] };
}

function setUnitResults(
  state: SearchStateInterface,
  action: ActionInterface<
    SearchActions,
    { units: Unit[]; query: string; searchOffset: number }
  >
): SearchStateInterface {
  if (!action.payload) {
    return state;
  }
  return {
    ...state,
    query: action.payload.query,
    results: action.payload.units,
    searchOffset: action.payload.searchOffset,
  };
}
